import { Link } from 'react-router-dom';
import styles from './announcement-board.module.sass';
import { LINE_URL } from 'config/config';
import { PATH } from 'config/path';

export const AnnouncementBoard = ({ alertType }) => {
  let color = '';
  let bgColor = '';
  let message = null;

  switch (alertType) {
    case 'no_payment':
      color = '#007AFF';
      bgColor = '#F2F8FF';
      message = (
        <>
          【預存金帳戶尚未開通】請聯繫 LINE 客服開通您的預存金帳戶。
          <a href={LINE_URL} target="_blank" rel="noreferrer">
            聯繫客服
          </a>
        </>
      );
      break;
    case 'no_license_plate':
      color = '#007AFF';
      bgColor = '#F2F8FF';
      message = (
        <>
          【尚未完成設定】請加入您的付款車牌，以開始付款。
          <Link to={PATH.LICENSE_PLATES}>前往新增車牌</Link>
        </>
      );
      break;
    case 'balance_low':
      color = '#F65555';
      bgColor = '#FFF5F6';
      message = (
        <>
          【預存金即將不足】請儘速補款以避免交易中斷，若需要匯款帳號，請聯繫 LINE 客服協助。
          <a href={LINE_URL} target="_blank" rel="noreferrer">
            聯繫客服
          </a>
        </>
      );
      break;
    default:
      return null;
  }

  return (
    <div
      className={styles['container']}
      style={{
        backgroundColor: bgColor,
        color: color,
      }}
    >
      <div className={styles['inner-container']}>{message}</div>
    </div>
  );
};
